// extracted by mini-css-extract-plugin
export default {"root":"SigningDocuments_root__mNvUC","title":"SigningDocuments_title__utM16","wrapper":"SigningDocuments_wrapper__T5nSH"};